import styled from 'styled-components';
import { theme } from '../../../configuration.js';

const HeaderMenuButton = styled.a`
  font-size: ${theme.sizes.header};
  padding: 4px 6px 4px 6px;
  margin-right: 10px;
  border-bottom: 3px solid ${props => props.isSelected ? theme.colours.main : '#ffffff'};
  background-color: ${props => props.isSelected ? theme.colours.headerSelectedColour : '#ffffff'};
  color: ${theme.colours.main};
  text-decoration: none;
  cursor: pointer;
  text-transform: uppercase;
  
  &:hover {
    border-bottom: 3px solid ${theme.colours.main};
  }
`;

export default HeaderMenuButton;
